import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {
    initializeVoiceEffect,
    initializeTransformEffect,
    VOICE_OPTIONS,
    TRANSFORM_OPTIONS,
    initializeFlowEffect,
    FLOW_OPTIONS,
} from './effect-types.js';
import Dropdown from 'react-dropdown';

const ChordEffectChooser = ({effect}) => { 
    let [option, setOption] = useState(undefined);

    const chooseFlowOption = useCallback(e => {
        let fx = initializeFlowEffect(effect.track, e.value);
        addEffect(fx);
    }, [effect, setOption]);

    const chooseVoiceOption = useCallback(e => {
        let fx = initializeVoiceEffect(effect.track, e.value);
        addEffect(fx);
    }, [effect, setOption]);

    const chooseTransformOption = useCallback(e => {
        let fx = initializeTransformEffect(effect.track, e.value);
        addEffect(fx);
    }, [effect, setOption]);

    const addEffect = useCallback((fx) => {
        effect.chordProgression.addEffect(fx);
        setOption(fx);
    }, [effect, setOption]);

    useEffect(() => {
        if (option) {
            setOption(null);
        }
    }, [setOption, option]);

    return (
        <div className="chord-effect-chooser">
          <Dropdown
            options={VOICE_OPTIONS}
            onChange={chooseVoiceOption}
            value={option}
            placeholder="Voices" />
          <Dropdown
            options={TRANSFORM_OPTIONS}
            onChange={chooseTransformOption}
            value={option}
            placeholder="Transforms" />
          <Dropdown
            options={FLOW_OPTIONS}
            onChange={chooseFlowOption}
            value={option}
            placeholder="Flow" />
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChordEffectChooser);
